




import { Component, Prop, Vue } from "vue-property-decorator";

import { ServiceMenuStatus, ServiceMenuStatusIconType } from "@/consts/const";

const CssStatusClassMap: { [key in ServiceMenuStatus]: string } = {
  [ServiceMenuStatus.Ok]: "ok",
  [ServiceMenuStatus.Warning]: "warning",
  [ServiceMenuStatus.Error]: "error",
  [ServiceMenuStatus.Notification]: "notification",
  [ServiceMenuStatus.Maintenance]: "maintenance",
};

const CssTypeClassMap: { [key in ServiceMenuStatusIconType]: string } = {
  [ServiceMenuStatusIconType.Explanation]: "explanation",
  [ServiceMenuStatusIconType.InSummary]: "in-summary",
  [ServiceMenuStatusIconType.InLine]: "in-line",
  [ServiceMenuStatusIconType.EventDetail]: "event-detail",
};

@Component({})
export default class ServiceMenuStatusIcon extends Vue {
  @Prop({ required: true }) private status!: ServiceMenuStatus;
  @Prop({ default: ServiceMenuStatusIconType.Explanation })
  private type!: ServiceMenuStatusIconType;

  private get cssClass(): { [key: string]: boolean } {
    return {
      [`service-menu-status-icon--${CssStatusClassMap[this.status]}`]: true,
      [`icon-size--${CssTypeClassMap[this.type]}`]: true,
    };
  }
}
